<section class="anexos" aria-labelledby="anexos-titulo">
  <h2 class="anexos-titulo" id="anexos-titulo">Anexos do pedido</h2>
  <span class="anexos-traco" aria-hidden="true"></span>

  <p class="anexos-texto">
    Adicione documentos que ajudem a explicar sua solicitação, se necessário. Incluir fotos, relatórios
    anteriores ou comprovantes pode agilizar a análise do SIC. O anexo é opcional.
  </p>

  @if (errosServidor().length || store.pendenciasAnexos().length) {
    <ul class="anexos-recusados" role="alert">
      @for (motivo of errosServidor(); track motivo) {
        <li class="anexos-recusado">
          <i-lucide name="circle-alert" size="16" aria-hidden="true"></i-lucide>
          {{ motivo }}
        </li>
      }
      @for (motivo of store.pendenciasAnexos(); track motivo) {
        <li class="anexos-recusado">
          <i-lucide name="circle-alert" size="16" aria-hidden="true"></i-lucide>
          {{ motivo }}
        </li>
      }
    </ul>
  }

  <label
    class="anexos-area"
    [attr.data-arrastando]="arrastando()"
    (dragover)="aoArrastar($event)"
    (dragleave)="aoSairDaArea()"
    (drop)="aoSoltar($event)"
  >
    <input
      class="anexos-campo"
      type="file"
      multiple
      [attr.accept]="aceitos()"
      (change)="aoSelecionar($event)"
    />

    <i-lucide class="anexos-icone" name="upload-cloud" size="30" aria-hidden="true"></i-lucide>

    <span class="anexos-area-titulo">Arraste e solte seus arquivos aqui ou clique para selecionar</span>

    <span class="anexos-area-texto">
      Formatos aceitos: {{ formatosEmTexto() }} (tamanho máximo: {{ tamanhoMaximoMb() }} MB por arquivo.
      Máximo {{ limites().quantidade }} arquivo(s))
    </span>
  </label>

  @if (recusados().length) {
    <ul class="anexos-recusados" role="alert">
      @for (motivo of recusados(); track motivo) {
        <li class="anexos-recusado">
          <i-lucide name="circle-alert" size="16" aria-hidden="true"></i-lucide>
          {{ motivo }}
        </li>
      }
    </ul>
  }

  <div class="anexos-tabela-caixa">
    <table class="anexos-tabela">
      <caption class="anexos-legenda">Arquivos anexados a este pedido</caption>

      <thead>
        <tr>
          <th scope="col">Nome</th>
          <th scope="col">Tamanho</th>
          <th scope="col">Ações</th>
        </tr>
      </thead>

      <tbody>
        @for (anexo of store.anexos(); track anexo.id) {
          <tr>
            <td class="anexos-nome">
              <i-lucide name="paperclip" size="16" aria-hidden="true"></i-lucide>
              {{ anexo.nome }}
            </td>
            <td class="anexos-tamanho">{{ formatarTamanho(anexo.tamanho) }}</td>
            <td class="anexos-acoes">
              <button
                type="button"
                class="anexos-remover"
                [attr.aria-label]="'Remover ' + anexo.nome"
                (click)="remover(anexo.id)"
              >
                <i-lucide name="trash-2" size="16" aria-hidden="true"></i-lucide>
              </button>
            </td>
          </tr>
        } @empty {
          <tr>
            <td class="anexos-vazio" colspan="3">Nenhum arquivo anexado</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</section>
